import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('TableColumn?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('TableColumn/show/'+id);
    },    
    create(params) {
        return Service().post('TableColumn/create', params);
    },
    update(id, params) {
        return Service().post('TableColumn/update/'+id, params);
    },
    delete(id) {
        return Service().post('TableColumn/delete/'+id);
    },
    column_list(params) {
        return Service().get('TableColumn/column-list/'+params);
    },
}